import {Component, OnInit} from '@angular/core';
import {LeadService} from '../services/lead.service';
import {Router, ActivatedRoute} from '@angular/router';
import {LeadsForm} from '../models/data-model';
import {GlobalDataService} from '../../housekeeping/services/global-data.service';

@Component({
    selector: 'app-lead-crud',
    templateUrl: '../views/lead-crud.component.html',
    styleUrls: ['../css/lead-crud.component.css']
})
export class LeadCrudComponent implements OnInit {
    public userId = sessionStorage.getItem("userId")
    public statusList: any;
    public priorityList: any;
    public leadSourceList: any;
    public countryList: any;
    public makeList: any = [];
    public makemodels: any = [];
    public makemodelsId: any = [];
    public currentvechliemodel = null;
    public currentVehicleList: any = [];
    public allcurrentVehicleList: any;
    public dealerList: any;
    public callToActionList: any;
    public timeFrameList: any;
    public showdealerList: boolean = false;
    public errorMessage = "";
    public dealerName = "";
    public adobeIdC = "";
    public assignedToList: any;
    public butDisabled: boolean = false;
    public isEventExist: boolean = false;
    public leadsheadername = "CREATE LEAD";
    public leadsForm = new LeadsForm("", "", {}, {}, {}, {
        id: "",
        firstName: "",
        lastName: "",
        companyName: "",
        phone: "",
        phoneTimeToCall: "",
        mobile: "",
        mobileTimeToCall: "",
        email: "",
        addressId: {
            id: "",
            address1: "",
            city: "",
            postalCode: "",
            stateId: {
                id: "",
                stateCode: "",
                name: ""
            },
            countryId: {
                id: "",
                code: "",
                name: ""
            }
        },
        assignedTo: {
            id: null,
            userName: "",
            firstName: "",
            lastName: ""
        }
    }, {}, {}, {}, {}, {}, {}, {}, {}, new Date(), "","","","","",new Date(), [], "", {}, "","","","");
    public leadno = "";
    public country = "";
    public address1 = "";
    public add_city = "";
    public userTZ = '';
    public oldEventId: any;
    public spinnerIcon = false;
    public showIcon = false;
    public vehiclePurposeList: any;
    submitted:boolean = false

    constructor(public _leadService: LeadService, public _router: Router, public activeroute: ActivatedRoute, private _globalService: GlobalDataService) {this.userTZ = this._globalService.USER_TZ;}

    ngOnInit() {
        this.getCountryList()
        this.getStatusList()
        this.getPriorityList()
        this.getLeadSourceList()
        this.getMakeList()
        this.getCurrentVehicle('')
        this.getDealerList()
        this.getcallToActionList()
        this.gettimeFrameList()
        this.getVehiclePurposeList()
        this.activeroute.params.subscribe(
            params => {
                if (Object.keys(params).length != 0) {
                    this.leadno = params.id
                    this.getLeadDeatails();
                    this.leadsForm.id = this.leadno
                    this.leadsheadername = "EDIT LEAD";
                    this.butDisabled = true;
                } else {
                    this.leadsForm.intentionId = {id: null, intention: null}
                    this.leadsForm.callToAction = {id: null, ctaType: null}
                    this.leadsForm.sourceId = {id: null, sourceType: null}
                    this.leadsForm.dealerId = {
                        id: "",
                        superDealerCode: null,
                        name: null,
                        globalCode: null,
                        localCode: null,
                        regionCode: null,
                        countryCode: null
                    }
                }
            });
    }
    /**
    * @author Pradeep
    * @description get vehicle purpose list
    */
    getVehiclePurposeList() {
        this._leadService.getVehiclePurposeList(this.userId, (result) => {
            this.vehiclePurposeList = result;
        });
    }
    /**
    * @author Pradeep
    * @description get country list
    */
    getCountryList() {
        this._leadService.getCountryList(this.userId, (result) => {
            this.countryList = result;
        });
    }

    /**
    * @author Pradeep
    * @description get status list
    */
    getStatusList() {
        this._leadService.getStatusList(this.userId, (result) => {
            this.statusList = result;
            this.leadsForm.statusId.id = this.statusList.find(x => x.statusType === 'New').id
        });
    }
    /**
     * @author Pradeep
     * @description get priority list
     */
    getPriorityList() {
        this._leadService.getPriorityList(this.userId, (result) => {
            this.priorityList = result;
        });
    }
    /**
     * @author Pradeep
     * @description lead source list
     */
    getLeadSourceList() {
        this._leadService.getLeadSourceList(this.userId, (result) => {
            this.leadSourceList = result;
        });
    }
    /**
    * @author Pradeep
    * @description lead source list
    */
    getMakeList() {
        this._leadService.getMakeList(this.userId, (result) => {
            this.makeList = result;
        });
    }
    /**
    * @author Pradeep
    * @description lead source list
    */
    getModelList(e) {
        let searchvalue = ""
        if (e != "") {
            this.leadsForm.vehicleOfInterest.model = ""
            searchvalue = e.target.value
        } else {
            searchvalue = this.leadsForm.vehicleOfInterest.make
        }
        this._leadService.getModelList(searchvalue, (result) => {
            this.makemodelsId = result;
            const listm = [];
            result.forEach(function (value) {
                listm.push(value.model);
            });
            this.makemodels = listm;
        });
    }
    /**
    * @author Pradeep
    * @description get all current vehicle list
    */
    getCurrentVehicle(e) {
        let searchvalue = ""
        if (e != '') {
            searchvalue = e.target.value
        }
        this._leadService.getCurrentVehicleList(searchvalue, (result) => {
            const listm = [];
            if( e == ""){
                this.allcurrentVehicleList= result
            }
            result.forEach(function (value) {
               const modelname = value.make + " " + value.model;
                listm.push(modelname);
            })
            this.currentVehicleList = listm;
        });
    }
    /*get current vechile id*/
    getCurrentVechileId(e) {
        let component = this
        const target = e
        if (this.allcurrentVehicleList.length > 0) {
            this.allcurrentVehicleList.forEach(function (value) {
                const modelname = value.make + " " + value.model
                if (modelname == target) {
                    component.leadsForm.currentVehicle.id = value.id
                    component.leadsForm.currentVehicle.make = value.make;
                    component.leadsForm.currentVehicle.model = value.model;
                }
            })
        }
    }

    /**
     * @author Pradeep
     * @description get all dealer list
     */
    getDealerList() {
        this._leadService.getDealerList(this.userId, (result) => {
          let sortedDealerList=result.sort((a, b) => a.globalCode - b.globalCode);
            this.dealerList = sortedDealerList;
            if (this.dealerList.length > 1) {
                this.showdealerList = true;
            }
        });
    }

    /**
    * @author Pradeep
    * @description get all assigned list
    */
    getAssignedToList() {
        this._leadService.getAssignedToList(this.leadsForm.dealerId.id, (result) => {
            this.assignedToList = result;
        });
    }

    /**
    * @author Pradeep
    * @description get dealar name based on dealer id
    */
    getDealerName(e) {
        if (this.dealerList.length > 1) {
            let dealername = "";
            let dealercode = "";
            this.dealerList.forEach(function (value) {
                if (value.id == e.target.value) {
                    dealername = value.name;
                    dealercode = value.globalCode;

                }
            })
            this.leadsForm.dealerId.name = dealername
            this.leadsForm.dealerId.globalCode = dealercode
            this.dealerName = dealername
            this.getAssignedToList()
        }
    }

    /**
    * @author Pradeep
    * @description get call to action list
    */
    getcallToActionList() {
        this._leadService.getcallToActionList(this.userId, (result) => {
            this.callToActionList = result;
        });
    }
    /**
    * @author Pradeep
    * @description get time frame list
    */
    gettimeFrameList() {
        this._leadService.gettimeFrameList(this.userId, (result) => {
            this.timeFrameList = result;
        });
    }

    getvehicleOfInterestId(model) {
        let component = this
        if (this.makemodelsId != "undefined") {
            if (this.makemodelsId.length > 0) {
                this.makemodelsId.forEach(function (value) {
                    if (value.model == model) {
                        component.leadsForm.vehicleOfInterest.id = Number(value.id);
                    }
                })
            }
        }
    }

    getCountryCodeName(id) {
        let component = this
        if (this.countryList.length > 0) {
            this.countryList.forEach(function (value) {
                if (value.id == id) {
                    component.leadsForm.prospectId.addressId.countryId.code = value.code;
                    component.leadsForm.prospectId.addressId.countryId.name = value.name;
                }
            })
        }
    }
    /**
     * @author Pradeep
     * @description save lead
     */
    saveLead() {
        this.errorMessage = "";
        this.leadsForm.userId = this.userId;
        this.leadsForm.submissionDate = null;
        this.leadsForm.companyName = this.leadsForm.prospectId.companyName;
        if (this.leadsForm.prospectId.addressId.countryId.id != null) {
            this.getCountryCodeName(this.leadsForm.prospectId.addressId.countryId.id)
        }
        if (this.leadsForm.assignedTo != null && this.leadsForm.assignedTo.id == null) {
            delete this.leadsForm.assignedTo.id
            delete this.leadsForm.assignedTo.userName
            delete this.leadsForm.assignedTo.firstName
            delete this.leadsForm.assignedTo.lastName
            this.leadsForm.assignedTo = null
        }
        if (this.leadsForm.dealerId != null && this.leadsForm.dealerId.id == null) {
            delete this.leadsForm.dealerId.id
            delete this.leadsForm.dealerId.superDealerCode
            delete this.leadsForm.dealerId.name
            delete this.leadsForm.dealerId.globalCode
            delete this.leadsForm.dealerId.localCode
            delete this.leadsForm.dealerId.regionCode
            delete this.leadsForm.dealerId.countryCode
            this.leadsForm.dealerId = null
        }
        if (this.leadsForm.teamId != null && this.leadsForm.teamId.id == null) {
            delete this.leadsForm.teamId.id
            delete this.leadsForm.teamId.name
            this.leadsForm.teamId = null
        }
        if (this.leadsForm.prospectId.addressId.stateId != null && this.leadsForm.prospectId.addressId.stateId.id == null) {
            delete this.leadsForm.prospectId.addressId.stateId.id
            delete this.leadsForm.prospectId.addressId.stateId.name
            delete this.leadsForm.prospectId.addressId.stateId.stateCode
            this.leadsForm.prospectId.addressId.stateId = null
        }
        if (this.leadsForm.prospectId.addressId.countryId != null && this.leadsForm.prospectId.addressId.countryId.id == null) {
            delete this.leadsForm.prospectId.addressId.countryId.id
            delete this.leadsForm.prospectId.addressId.countryId.name
            delete this.leadsForm.prospectId.addressId.countryId.code
            this.leadsForm.prospectId.addressId.countryId = null
        }
        if (this.leadsForm.sourceId != null && this.leadsForm.sourceId.id == null) {
            delete this.leadsForm.sourceId.id
            delete this.leadsForm.sourceId.sourceType
            this.leadsForm.sourceId = null
        }
        if (this.leadsForm.priorityId != null && this.leadsForm.priorityId.id == null) {
            delete this.leadsForm.priorityId.id
            delete this.leadsForm.priorityId.priority
            this.leadsForm.priorityId = null
        }
        if (this.leadsForm.intentionId != null && this.leadsForm.intentionId.id == null) {
            delete this.leadsForm.intentionId.id
            delete this.leadsForm.intentionId.intention
            this.leadsForm.intentionId = null
        }
        if (this.leadsForm.currentVehicle != null && this.leadsForm.currentVehicle.id == null) {
            delete this.leadsForm.currentVehicle.id
            delete this.leadsForm.currentVehicle.make
            delete this.leadsForm.currentVehicle.model
            this.leadsForm.currentVehicle = null
        }
        if (this.leadsForm.vehicleOfInterest != null) {

            if (this.leadsForm.vehicleOfInterest.model != null && this.leadsForm.vehicleOfInterest.make != '') {
                this.getvehicleOfInterestId(this.leadsForm.vehicleOfInterest.model)
            } else {
                delete this.leadsForm.vehicleOfInterest.id
                delete this.leadsForm.vehicleOfInterest.make
                delete this.leadsForm.vehicleOfInterest.model
                this.leadsForm.vehicleOfInterest = null
            }
        }
        if (this.leadsForm.callToAction.id == null) {
            delete this.leadsForm.callToAction.id
            delete this.leadsForm.callToAction.ctaType
            this.leadsForm.callToAction = null
        }
        if (this.leadsForm.statusId.id == null) {
            delete this.leadsForm.statusId.id
            delete this.leadsForm.statusId.statusType
            this.leadsForm.statusId = null
        }
        this._leadService.saveLead(this.leadsForm, (result) => {
            if (result.statusCodes == "LEAD_SAVED_SUCCESSFULLY") {
                console.clear()
                this.leadsForm.id = result.id;
                if (this.leadsForm.id != '' && this.leadsForm.id != undefined) {
                    this._router.navigate(['leads/detail/' + this.leadsForm.id]);
                } else {
                    this._router.navigate(['leads']);
                }
            } else {
                this.errorMessage = "Something went wrong!!"
                this._router.navigate(['leads/create']);
            }
        });
    }

    /**
     * @author Pradeep
     * @description get lead details
     */
    getLeadDeatails() {
        this._leadService.viewLeadsDetails(this.leadno, this.userId, (result) => {
            this.adobeIdC= result.adobeIdC;
            if (result.id != null) {
                this.leadsForm.id = result.id
            } else {
                this.leadsForm.id = null
            }
            if (result.assignedTo != null) {
                this.leadsForm.assignedTo = result.assignedTo
            } else {
                this.leadsForm.assignedTo = null
            }
            if (result.dealerId != null) {
                this.leadsForm.dealerId = result.dealerId
            } else {
                this.leadsForm.dealerId = null
            }
            if (result.prospectId != null) {
                this.leadsForm.prospectId = result.prospectId
            } else {
                this.leadsForm.prospectId = null
            }
            if (result.userId != null) {
                this.leadsForm.userId = result.userId
            } else {
                this.leadsForm.userId = null
            }
            if (result.sourceId != null) {
                this.leadsForm.sourceId = result.sourceId
            } else {
                this.leadsForm.sourceId = null
            }
            if (result.priorityId != null) {
                this.leadsForm.priorityId = result.priorityId
            } else {
                this.leadsForm.priorityId = null
            }
            if (result.intentionId != null) {
                this.leadsForm.intentionId = result.intentionId
            } else {
                this.leadsForm.intentionId = {id: null, intention: null}
            }
            if (result.eventId != null) {
                this.leadsForm.eventId = result.eventId
            } else {
                this.leadsForm.eventId = {id: null, eventId: null, eventDescription: null};
            }
            if (result.currentVehicle != null) {
                this.leadsForm.currentVehicle = result.currentVehicle
            } else {
                this.leadsForm.currentVehicle = null
            }
            if (result.vehicleOfInterest != null) {
                this.leadsForm.vehicleOfInterest = result.vehicleOfInterest
                if (result.vehicleOfInterest.model == '') {
                    this.leadsForm.vehicleOfInterest.model = null
                } if (result.vehicleOfInterest.make == '' || result.vehicleOfInterest.make == null) {
                    this.leadsForm.vehicleOfInterest.make = ''
                }
            } else {
                this.leadsForm.vehicleOfInterest = {id: null, make: '', model: null};
            }
            if (result.callToAction != null) {
                this.leadsForm.callToAction = result.callToAction
            } else {
                this.leadsForm.callToAction = null
            }
            if (result.statusId != null) {
                this.leadsForm.statusId = result.statusId
            } else {
                this.leadsForm.statusId = {id: null, statusType: null}
            }
            if (result.submissionDate != null) {
                this.leadsForm.submissionDate = result.submissionDate
            } else {
                this.leadsForm.submissionDate = null
            }
            if (result.activity != null) {
                this.leadsForm.activity = result.activity
            } else {
                this.leadsForm.activity = null
            }
            if (result.vehiclePurposeId != null) {
                this.leadsForm.vehiclePurposeId = result.vehiclePurposeId
            } else {
                this.leadsForm.vehiclePurposeId = {id: null, code: null, description: null, active: false};
            }
            if (result.comments != null) {
                this.leadsForm.comments = result.comments
            } else {
                this.leadsForm.comments = null
            }
            if (result.eventId != null) {
                this.oldEventId = result.eventId.eventId
            }
            if (result.currentVehicle != null) {
                if (result.currentVehicle.make != null) {
                    this.currentvechliemodel = result.currentVehicle.make + " " + result.currentVehicle.model
                }
            } else {
                this.leadsForm.currentVehicle = {id: null, make: "", model: null};
            }

            if (result.assignedTo != null) {
                this.leadsForm.assignedTo = result.assignedTo
            }
            else {
                this.leadsForm.assignedTo = {id: null, userName: null, firstName: null, lastName: null};
            }
            if(result.leadNumber != null){
                this.leadsForm.leadNumber = result.leadNumber;
            }
            else{
                this.leadsForm.leadNumber = null;
            }
            if(result.website != null){
                this.leadsForm.website = result.website;
            }
            else{
                this.leadsForm.website = null;
            }
            if(result.campaignName != null){
                this.leadsForm.campaignName = result.campaignName;
            }
            else{
                this.leadsForm.campaignName = null;
            }
            this.dealerName = this.leadsForm.dealerId.name;
            this.leadsForm.adobeIdC = result.adobeIdC;
            if (this.leadsForm.prospectId.addressId == null) {
                this.leadsForm.prospectId.addressId = {
                    id: null,
                    address1: "",
                    city: "",
                    postalCode: "",
                    stateId: {
                        id: null,
                        stateCode: "",
                        name: ""
                    },
                    countryId: {
                        id: null,
                        code: "",
                        name: ""
                    }
                }
            }
            if (this.leadsForm.prospectId.addressId.countryId == null) {
                this.leadsForm.prospectId.addressId.countryId = {'id': "", 'code': "", 'name': ""}
            }
            this.getAssignedToList()
            this.getModelList("")


        })
    }
    /**
    * @author Sowmya
    * @description cancel create or edit
    */
    cancel() {
        if (this.leadsForm.id != '' && this.leadsForm.id != undefined) {
            this._router.navigate(['leads/detail/' + this.leadsForm.id]);
        } else {
            this._router.navigate(['leads']);
        }
    }


    /**
     * @author Anand
     * @description Check event id already exist or not.
     */
    checkEventId() {
        this.showIcon = false;
        this.spinnerIcon = false;
        this.isEventExist = false;
        if (this.leadsForm.eventId.eventId != null && this.oldEventId != this.leadsForm.eventId.eventId) {
            this.showIcon = true;
            this.spinnerIcon = true;
            this._leadService.checkEventId(this.leadsForm.eventId, (result) => {
                this.isEventExist = result;
                this.spinnerIcon = false;
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/leads/components/lead-crud.component.ts